/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon24Solid = forwardRef('ArrowADownRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.879 18H8a1.5 1.5 0 0 0 0 3h9.5a3.5 3.5 0 0 0 3.5-3.5V8a1.5 1.5 0 0 0-3 0v7.879L6.06 3.939a1.5 1.5 0 1 0-2.12 2.122L15.878 18Z" })));
});
